import Vue from 'vue'
import createMutationsSharer from "vuex-shared-mutations";
import Vuex from 'vuex'
import auth from './auth'
import activities from './activities'
import evaluations from './evaluations'
import arceClients from './arce/clients'
import arceStatus from './arce/status'
import arceDetails from './arce/details'
import arceEeff from './arce/eeff'

import pfAnalysis from './pf/analysis/index'
import pfClients from './pf/clients/index'
import pfStatus from './pf/status/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
	auth,
	// Micrositio
	activities,
	evaluations,
	// ARCE
	arceClients,
	arceStatus,
	arceDetails,
	arceEeff,
	// PF
	pfAnalysis,
	pfClients,
	pfStatus,
  },
  plugins: [createMutationsSharer({ predicate: [] })]
})
